<template>
	<div class="adsOnlineAutoList">
		<filter-panel :data="groups" @search="filterChange"></filter-panel>
		<div class="row-bg">
			<el-row type="flex" justify="end">
				<!-- <span class="row-text">账户已上线： {{ statistimeObj.onlineNum || '-' }}</span> -->
				<span class="row-text">平均用时(全部)：{{ statistimeObj.avgOnlineTimeStr || '-' }}</span
				><span class="row-text"> 最快用时(全部)：{{ statistimeObj.minOnlineTimeStr || '-' }}</span>
			</el-row>
			<el-row type="flex" justify="end" style="margin-top: 5px">
				<span class="row-text">平均用时(我的)：{{ statistimeObj.myAvgOnlineTimeStr || '-' }}</span
				><span class="row-text">
					最快用时(我的)：{{ statistimeObj.myMinOnlineTimeStr || '-' }}</span
				>
			</el-row>
		</div>
		<data-list
			class="bg"
			style="margin-top: 10px"
			:page="page"
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="columns"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
		<logPage :dialogVisible.sync="visible" :automationId="automationId"></logPage>
	</div>
</template>
<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import logPage from '@/components/accountOnline/logPage';
import customerMinxins from '@/mixins/customer';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
const list = listPageCreate({
	searchConfig: {
		api: api.adsNewOnline.customerlist,
		method: 'POST',
	},
});
export default {
	mixins: [list, customerMinxins],
	data() {
		let that = this;
		return {
			groups: {
				others: [
					{
						label: '查询服务单',
						tagName: 'sky-input',
						placeholder: '查询服务单',
						prop: 'serviceCode',
						value: '',
					},
					{
						label: '查询CID',
						tagName: 'sky-input',
						placeholder: '查询CID',
						prop: 'googleCid',
						value: '',
					},
					{
						label: '选择状态',
						tagName: 'sky-select',
						prop: 'status',
						placeholder: '请选择状态',
						options: [
							{
								label: '待优化师填写',
								value: 1,
							},
							{
								label: '待客户确认',
								value: 2,
							},
							{
								label: '客户提交待上线',
								value: 3,
							},
							{
								label: '已上线',
								value: 4,
							},
							{
								label: '上线中',
								value: 5,
							},
							{
								label: '上线失败',
								value: 6,
							},
						],
						value: '',
					},
					{
						label: '查询优化师',
						tagName: 'sky-input',
						placeholder: '查询优化师',
						prop: 'serviceStaffName',
						value: '',
					},
				],
			},
			columns: [
				{
					label: '客户名称',
					bind: 'customerName',
					minWidth: 200,
				},
				{
					label: '服务单号/主域名',
					minWidth: 180,
					type: 'custInfo',
					style: {
						textAlign: 'left',
					},
					text: [
						{
							label: '',
							bind: 'serviceCode',
						},
						{
							label: '',
							bind: 'domain',
						},
					],
				},
				{
					label: 'CID',
					bind: 'googleCid',
					minWidth: 100,
				},
				{
					label: '状态',
					type: 'mapping',
					minWidth: 120,
					parentEvent(type) {
						var name = '-';
						switch (type) {
							case 1:
								name = '待优化师填写';
								break;
							case 2:
								name = '待客户确认';
								break;
							case 3:
								name = '客户提交待上线';
								break;
							case 4:
								name = '已上线';
								break;
							case 5:
								name = '上线中';
								break;
							case 6:
								name = '上线失败';
								break;
						}
						return name;
					},
					mapType: 'text',
					bind: 'status',
					colors(row) {
						var color = {};
						switch (row.status) {
							case 1:
								color = {
									color: '#FCC262',
								};
								break;

							case 2:
								color = {
									color: '#FCC262',
								};
								break;
							case 3:
								color = {
									color: '#FCC262',
								};
								break;
							case 4:
								color = {
									color: '#67C23A',
								};
								break;
							case 5:
								color = {
									color: '#FCC262',
								};
								break;
							case 6:
								color = {
									color: '#FF3000',
								};
								break;
						}
						return color;
					},
				},
				{
					label: '账户上线用时',
					content:
						'账户已上线的，表示从网站上线到账户上线的总用时<br/>账户未上线的，表示此时距网站上线的总用时',
					bind: 'onlineTimeStr',
					minWidth: 150,
					type: 'mapping',
					mapType: 'text',
					colors(row) {
						var style = {};
						if (row.status != 4) {
							style = {
								fontWeight: 600,
							};
						}
						return style;
					},
					sort: 'onlineTimeStr',
					options: [
						{
							label: '由小到大',
							value: 'asc',
						},
						{
							label: '由大到小',
							value: 'desc',
						},
					],
				},

				{
					label: '优化师',
					bind: 'serviceStaffName',
					minWidth: 80,
				},
				{
					label: '时间',
					bind: 'operationTime',
					type: 'mapping',
					minWidth: 250,
					parentEvent(operationTime, row) {
						return row.operationTypeName
							? `${row.operationTypeName}:${operationTime || '-'}`
							: operationTime || '-';
					},
					mapType: 'text',
					trigger: 'hover',
					multidataMapping(row) {
						return `<div style="padding-bottom:5px">网站首次上线:${
							row.onlineTime || '-'
						}</div><div style="padding-bottom:5px">发送客户初始方案:${
							row.sendCustomerTime || '-'
						}</div><div style="padding-bottom:5px">客户确认方案:${
							row.customerConfirmTime || '-'
						}</div><div>账户搭建成功:${row.buildTime || '-'}</div>`;
					},
				},

				{
					label: '操作人',
					bind: 'accountName',
					type: 'mapping',
					minWidth: 200,
					parentEvent(accountName, row) {
						return row.accountPosition
							? `${row.accountPosition}:${accountName}`
							: accountName || '-';
					},
					mapType: 'text',
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'left',
					style: 'text',
					minWidth: 220,
					bind() {
						let arr = [
							{
								text: '开始填写初始方案',
								trigger(row) {
									that.$store.dispatch('getstepstatus', row.id);
									//跳转
									that.$router.push({
										name: 'adsSkeleton',
										query: {
											id: row.id,
											projectId: row.projectId,
											name: row.domain,
											serviceSiteId: row.serviceId,
											automationStatus: row.status,
											customerId: row.customerId,
										},
									});
								},
								showButton(row) {
									return row.status == 1;
								},
							},
							{
								text: '查看方案',
								trigger(row) {
									that.$store.dispatch('getstepstatus', row.id);
									//待客户确认展示流程方案
									if (row.status == 2) {
										that.$router.push({
											name: 'showAdsSkeleton',
											query: {
												id: row.id,
												projectId: row.projectId,
												name: row.domain,
												serviceSiteId: row.serviceId,
												automationStatus: row.status,
												customerId: row.customerId,
												// activeValue:6,
											},
										});
									} else {
										that.$router.push({
											name: 'launchPlan',
											query: {
												id: row.id,
												projectId: row.projectId,
												name: row.domain,
												serviceSiteId: row.serviceId,
												automationStatus: row.status,
												isShow: '0', //0为不显示
												customerId: row.customerId,
											},
										});
									}
								},
								showButton(row) {
									return row.status != 1;
								},
							},
							{
								text: '账户上线',
								trigger(row) {
									that.$router.push({
										name: 'accountOnline',
										query: {
											id: row.id,
											serviceSiteId: row.serviceId,
											automationId: row.id,
											automationStatus: row.status,
										},
									});
								},
								showButton(row) {
									// 解构赋值获取所需属性
									const { googleCid, status } = row;
									// 定义允许显示按钮的状态集合，语义化命名
									const allowShowStatus = new Set([3, 5, 6]);

									// 逻辑：googleCid存在 且 状态在允许的集合中
									return !!googleCid && allowShowStatus.has(status);
								},
							},
							{
								text: '查看修改日志',
								trigger(row) {
									that.automationId = row.id;
									that.visible = true;
								},
								showButton(row) {
									return row.status != 1;
								},
							},
							{
								text: '失败原因',
								trigger(row) {
									let { reason } = row;
									const h = that.$createElement;

									that.$msgbox({
										title: '失败原因',
										message: h(
											'div',
											{ style: { whiteSpace: 'pre', maxHeight: '450px', overflowY: 'auto' } },
											reason
										),
										confirmButtonText: '确定',
										customClass: 'reasonMsgBox',
										callback: () => {},
									});
								},
								showButton(row) {
									return row.status == 6;
								},
							},
						];

						return arr;
					},
				},
			],
			visible: false,
			automationId: '',
			statistimeObj: {},
		};
	},
	components: { filterPanel, logPage },
	computed: {},
	methods: {
		async getStatistime() {
			let res = await adsNewOnlineSer.statistime();
			if (res.data) {
				this.statistimeObj = res.data;
			}
		},
	},
	mounted() {
		this.query();
		this.getStatistime();
	},
};
</script>
<style lang="scss" scoped>
.bg {
	background: #fff;
	margin: 10px 0;
	padding: 10px;
}
.row-text {
	display: inline-block;
	min-width: 230px;
	font-size: 14px;
	margin-right: 15px;
	color: #000000;
}
</style>

<style lang="scss">
.reasonMsgBox {
	width: auto !important;
}
</style>
